import React, {Component} from "react"
import Papa from "papaparse"
import moment from "moment"

import {injectIntl, InjectIntl} from "@irati/utils/lang"
import adminReportingService from "@irati/adminReporting/services/adminReporting"
import authentication from "@irati/auth"
import makeCSV from "@irati/utils/csv/makeCSV"

import {ALL_TEAMS} from "../../../Region"
import DownloadButton from "../Download"

interface Props extends InjectIntl {
  showButtons: boolean
  onDownload?: () => void
  hideText?: boolean
}

interface State {
  load: Promise<void> | null
}

class MostPopularPollsDownload extends Component<Props, State> {
  state = {
    load: null
  }

  downloadReport = () => {
    const {formatMessage, regionId, duration, category} = this.props

    const regionIds = regionId !== ALL_TEAMS ? [regionId] : undefined

    const load = adminReportingService
      .getCelebrationsReport({
        businessId: authentication.business().uuid,
        regionIds,
        duration,
        category
      })
      .then(({polls}) => {
        const headers = [
          formatMessage({id: "admin.reporting.celebrations.polls.mostPopular.headers.title"}),
          formatMessage({id: "admin.reporting.celebrations.polls.mostPopular.headers.criteria"}),
          formatMessage({id: "admin.reporting.celebrations.polls.mostPopular.headers.companyValues"}),
          formatMessage({id: "admin.reporting.celebrations.polls.mostPopular.headers.totalVotes"}),
          formatMessage({id: "admin.reporting.celebrations.polls.mostPopular.headers.votingPeriod"}),
          formatMessage({id: "admin.reporting.celebrations.polls.mostPopular.headers.totalNominees"})
        ]

        const data = polls.polls.map((p) => {
          const startOfPoll = moment.unix(p?.createdAt?.seconds)
          const endOfPoll = moment.unix(p?.voteEndedAt?.seconds)
          const pollLengthInDays = Math.ceil(moment.duration(endOfPoll.diff(startOfPoll)).asDays())
          return [
            p.title,
            p.criteria,
            p.companyValues.results.map(({name}) => name).join(", "),
            p.totalVotes,
            formatMessage({id: "admin.reporting.celebrations.pollCard.votingPeriod.value"}, {days: pollLengthInDays}),
            p.totalNominees
          ]
        })
        const csv = Papa.unparse({fields: headers, data})
        makeCSV(csv, "mostPopularPolls.csv")
      })

    this.setState({load})
  }

  render() {
    const {load} = this.state
    const {hideText} = this.props

    return (
      <DownloadButton
        hideText={hideText}
        tooltip="admin.reporting.celebrations.polls.mostPopular.tooltip"
        load={load}
        onClick={this.downloadReport}
      />
    )
  }
}

export default injectIntl(MostPopularPollsDownload)
